import { render } from "./ImportMnemonic.vue?vue&type=template&id=2f6077f0&scoped=true"
import script from "./ImportMnemonic.vue?vue&type=script&lang=js"
export * from "./ImportMnemonic.vue?vue&type=script&lang=js"

import "./ImportMnemonic.vue?vue&type=style&index=0&id=2f6077f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6077f0"]])

export default __exports__